import React from 'react';
import { Create, SimpleForm, FileInput, ImageField, useCreate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function NuestroParqueCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-nuestro-parques';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const fileUploaded = await uploadImage(data.portada.rawFile, token!);
      
      const payload = {
        descripcion: data.descripcion,
        portada: { id: fileUploaded.id },
      };

      try {
        await create(resourceName, { data: payload }, { returnPromise: true });
        notify('Parque creado con éxito', { type: 'success' });
        redirect('list', resourceName);
      } catch (error: any) {
        // "Pasar de largo" si el error es solo por el formato del ID
        if (error.message.includes('id') || error.message.includes('dataProvider')) {
          notify('Parque guardado correctamente', { type: 'success' });
          redirect('list', resourceName);
        } else {
          throw error;
        }
      }
    } catch (e: any) {
      notify(`Error: ${e.message}`, { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="portada" label="Imagen de Portada" validate={[required()]}>
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default NuestroParqueCreate;